import { post } from '@/util/request'

export default {
  /**
   * 用户列表（供只读配置使用）
   * @param query
   * @returns {*}
   */
  readList: query => post(`/system/readList`, query),

  /**
   * 变更用户只读状态
   * @param query
   * @returns {*}
   */
  changeReadOnly: query => post(`/system/changeReadOnly`, query),

  /**
   * 专题可见配置用户列表
   * @param query
   * @returns {*}
   */
  viewerPage: query => post(`/keyword/viewerPage`, query),

  /**
   * 修改专题用户可见配置
   * @param query
   * @returns {*}
   */
  changeViewerStatus: query => post(`/keyword/changeViewerStatus`, query),

}
